import { FaCode, FaStar, FaDownload } from "react-icons/fa";
import "./style.scss";
import Button from "../../ReusableComponent/Button";

const EarnedCertificate = ({
  title,
  subject,
  level,
  issueDate,
  score,
  verificationId,
  onDownload,
  onVerify,
}) => {
  return (
    <div className="col-md-4 col-12 mb-4">
      <div className="certificate-card h-100 hover-card">
        <div className="p-4">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div className="d-flex align-items-center">
              <FaCode className="me-2 text-primary" size={20} />
              <div>
                <h5 className="fw-bold mb-1">{title}</h5>
                <small className="text-muted">{subject}</small>
              </div>
            </div>
            <span className="badge bg-primary">{level}</span>
          </div>

          {/* Issue Date & Score */}
          <div className="row mx-0 mb-3">
            <div className="col-6">
              <small className="text-muted">Issue Date</small>
              <div className="fw-medium">{issueDate}</div>
            </div>
            <div className="col-6">
              <small className="text-muted">Score</small>
              <div className="fw-medium d-flex align-items-center">
                {score}% <FaStar className="ms-1 text-warning" size={14} />
              </div>
            </div>
          </div>

          {/* Verification ID */}
          <div className="mb-3">
            <small className="text-muted">Verification ID</small>
            <div className="font-monospace small">{verificationId}</div>
          </div>

          {/* Actions */}
          <div className="d-flex gap-2">
            {/* <button className="btn btn-primary flex-fill" onClick={onDownload}>
              <FaDownload className="me-1" size={14} /> Download
            </button> */}
            <Button variant="gradient" onClick={onDownload}>
               <FaDownload className="me-1" size={14} /> Download
            </Button>
            <button
              className="btn btn-outline-primary flex-fill"
              onClick={onVerify}
            >
              Verify
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarnedCertificate;